import { useEffect, useState } from 'react';
import api from '../services/api';

// Quem vê a página /softwares (menu e rotas). Quem decide é a API (GET /softwares/acesso,
// backend/src/routes/softwares.js): a equipe Exxer (admin e exxer) sempre; os clientes
// (coordenador, professor, aluno e temporário) só quando o admin liberou ao menos um software.
// `gerenciar`: só o admin liga e desliga cada software para os clientes.
// A resposta fica guardada por usuário e papel ativo, para o menu e a rota não perguntarem
// duas vezes; o cliente vê um software recém-liberado ao recarregar a página ou entrar de novo.
let guardado = { chave: null, promessa: null };

const SEM_ACESSO = { visivel: false, gerenciar: false };

const consultar = (chave) => {
  if (guardado.chave !== chave || !guardado.promessa) {
    guardado = {
      chave,
      promessa: api.get('/softwares/acesso')
        .then(({ data }) => ({ visivel: Boolean(data?.visivel), gerenciar: Boolean(data?.gerenciar) }))
        .catch(() => {
          guardado = { chave: null, promessa: null };
          return SEM_ACESSO;
        })
    };
  }
  return guardado.promessa;
};

/** { carregando, visivel, gerenciar } para o usuário logado. */
export const useAcessoSoftwares = (usuario) => {
  // a sessão da TV do Andon não vê a página (a API responde 403): nem pergunta
  const chave = usuario?.id && usuario.andon !== 'tv' ? `${usuario.id}:${usuario.tipo_usuario}` : null;
  const [estado, setEstado] = useState({ chave: null, ...SEM_ACESSO });

  useEffect(() => {
    if (!chave) return undefined;
    let vivo = true;
    consultar(chave).then((acesso) => { if (vivo) setEstado({ chave, ...acesso }); });
    return () => { vivo = false; };
  }, [chave]);

  if (!chave) return { carregando: false, ...SEM_ACESSO };
  if (estado.chave !== chave) return { carregando: true, ...SEM_ACESSO };
  return { carregando: false, visivel: estado.visivel, gerenciar: estado.gerenciar };
};
